module.exports = __webpack_public_path__ + "static/media/Walk-through_Check-in_3.0a9db191.jpg";